// extracted by mini-css-extract-plugin
export default {"container":"SmallInput_container__C8CWl"};